import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Link as RouterLink } from "react-router-dom";

import LogoImage from "images/splash_logo.png";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as LinkedinIcon } from "images/linkedin-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-9.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";

const Container = tw.div`relative bg-primary-500 text-gray-100 -mx-8 -mb-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const FiveColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/3 md:w-auto mt-12`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-100 pb-1 transition duration-300`;

const Divider = tw.div`my-16 border-b-2 border-primary-400 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-100`;

const CopyrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-400`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-400 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute top-0 left-0 w-80 h-80 transform -translate-x-20 -translate-y-32 text-primary-700 opacity-50`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob1
)`absolute bottom-0 right-0 w-80 h-80 transform  translate-x-32 translate-y-48 text-primary-700 opacity-50`;

const date = new Date();
export default () => {
  return (
    <Container>
      <Content>
        <FiveColumns>
          <Column>
            <ColumnHeading>Principal</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link as={RouterLink} to="/blog">Blog</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/faq">FAQ</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/support">Support</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/about">À Propos</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Produit</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="https://dashboard.tangagroup.africa" target="_blank" rel="noopener noreferrer">Connexion</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/products">Produits</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/#usecases">Cas d'usage</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/#services">Services</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          {/* <Column>
            <ColumnHeading>Presse</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">Logos</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Événements</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Histoires</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Bureau</Link>
              </LinkListItem>
            </LinkList>
          </Column> */}
          <Column>
            <ColumnHeading>Équipe</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link as={RouterLink} to="/careers">Carrières</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/founders">Fondateurs</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/culture">Culture</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/onboarding">Intégration</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Légal</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link as={RouterLink} to="/rgpd">RGPD</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/privacy">Politique de Confidentialité</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/terms">Conditions d'Utilisation</Link>
              </LinkListItem>
              <LinkListItem>
                <Link as={RouterLink} to="/legal">Mentions Légales</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </FiveColumns>
        <Divider />
        <ThreeColRow>
          <LogoContainer>
            <LogoImg src={LogoImage} />
            <LogoText>Tanga Africa</LogoText>
          </LogoContainer>
          <CopyrightNotice>&copy; {new Date().getFullYear()} Tanga Africa Tous droits réservés.</CopyrightNotice>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com/tanga">
              <FacebookIcon />
            </SocialLink>
            {/* <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink> */}
            <SocialLink href="https://www.linkedin.com/company/tanga-africa">
              <LinkedinIcon />
            </SocialLink>
            <SocialLink href="https://www.youtube.com/@TangaAfrica">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
      {/* <DecoratorBlobContainer>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </DecoratorBlobContainer> */}
    </Container>
  );
};